<template>
  <div class="p-4 sm:p-6 lg:p-10 max-w-7xl mx-auto">
   
    <template v-if="myCourses.length > 0">
    <PageHeader
      title="Rozpoczęte kursy"
      subtitle="Lista kursów, na które jesteś zapisany. Sprawdź szczegóły, terminy zajęć i materiały do pobrania. Kontynuuj swoją przygodę z improwizacją już dziś!"
    />

     <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 reservepro-schedule">
       <CourseDetails 
         v-for="course in myCourses" 
         :key="course.id"
         :group="course"
       />
     </div>
      </template>

    <PageHeader
      title="Kursy, które mogą Cię zainteresować"
      subtitle="Zapisz się już dziś i zacznij swoją przygodę w Akademii Improwizacji! Early Access!"
    />




    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 reservepro-schedule">
      <CourseCard 
        v-for="course in additionalCourses" 
        :key="course.id"
        :group="course"
      />
    </div>



    </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue';
import CourseCard from '../../components/customer/CourseCard.vue';
import CourseDetails from '../../components/customer/CourseDetails.vue';
import rpAPI from '@shared/service/rpAPI.js';
import Globals from '@shared/model/Globals.js';
import GroupReservation from '@shared/model/Reservation.js';


export default {
  name: 'CoursesPage',
  components: {
    PageHeader,
    CourseCard,
    CourseDetails
  },

  data() {
    return {
      myCourses: [],
      additionalCourses: []
    };
  },
 
 
  async mounted() {
      const user = rpAPI.user;

      if (!user) return;
      await user.initProfiles();


      let allGroups = await GroupReservation.fetchAllGroups();

      console.log('All groups:', allGroups);
      
      // usuń grupy, na które użytkownik jest już zapisany
      const defaultProfile = user.defaultProfile();     
      const groupIds = await user.getAllGroupsForProfile(defaultProfile);

      let additionalCourses = allGroups.filter(group => !groupIds.includes(group.id) && group.noAvailability !== true);
      let myCourses = allGroups.filter(group => groupIds.includes(group.id));
    
      // Weź mój poziom umiejętności z profilu użytkownika
      const myLevel = defaultProfile.level || [];

      additionalCourses = additionalCourses.filter(group => group.validateRequirements(myLevel));

      this.additionalCourses = additionalCourses;
      this.myCourses = myCourses;
}
}


</script>